const colors = {
	primary: '#007AB3',
	primaryLight: '#e6f7ff',
	primaryLighter: '#FBFAFB',
	primaryDark: '#005e8a',
	primaryDarker: '#10318C',

	secondary: '#FF6419',
	secondaryLight: '#ff884e',
	secondaryLighter: '#f8dbcc',
	secondaryDark: '#cb4e1c',
	secondaryDarker: '#501f12',

	tertiary: '#ffffff',
	tertiaryLight: '#ffffff',
	tertiaryLighter: '#ffffff',
	tertiaryDark: '#ffffff',
	tertiaryDarker: '#ffffff',

	white: '#FFFFFF',
	greyLight: '#E3E1E3',
	grey: '#818181',
	greyDark: '#4a4a4a',
	black: '#414141',

	danger: '#FF6419',
	success: '#3DA556',
};

export default colors;
